// todo: remove me in v13 update after the migration of 'udg_LocationsMap' -> 'udg_Locations'
export default function () {
    const $map = document.querySelector('#isnack-locations-map');

    if (!$map) {
        return;
    }

    const windowWidth = (window.innerWidth ? window.innerWidth : window.innerWidth) > 768;

    const options = {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        center: {
            lat: 30,
            lng: 30,
        },
        zoom: windowWidth ? 2 : 1,
        minZoom: 1,
        maxZoom: 7,
    };

    const earthColor = '#b9b9b9';
    const strokeColor = '#ffffff';
    const waterColor = '#f4f4f4';

    const stylers = [
        {
            elementType: 'labels.icon',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            elementType: 'labels.text',
            stylers: [
                {
                    color: earthColor,
                },
                {
                    weight: 0.5,
                },
            ],
        },
        {
            elementType: 'labels.text.stroke',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'administrative',
            elementType: 'labels.text',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'administrative',
            elementType: 'geometry.fill',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'administrative.country',
            stylers: [
                {
                    visibility: 'simplified',
                },
            ],
        },
        {
            featureType: 'administrative.country',
            elementType: 'labels.text',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'administrative.country',
            elementType: 'geometry.stroke',
            stylers: [
                {
                    color: strokeColor,
                },
                {
                    visibility: 'on',
                },
            ],
        },
        {
            featureType: 'administrative.land_parcel',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'administrative.locality',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'administrative.locality',
            elementType: 'geometry',
            stylers: [
                {
                    color: earthColor,
                },
            ],
        },
        {
            featureType: 'administrative.locality',
            elementType: 'labels.text',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'administrative.neighborhood',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'administrative.province',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'landscape',
            elementType: 'geometry.fill',
            stylers: [
                {
                    color: earthColor,
                },
            ],
        },
        {
            featureType: 'landscape',
            elementType: 'labels.text',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'poi',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'road',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'transit',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
        {
            featureType: 'water',
            elementType: 'geometry.fill',
            stylers: [
                {
                    color: waterColor,
                },
            ],
        },
        {
            featureType: 'water',
            elementType: 'labels.text',
            stylers: [
                {
                    visibility: 'off',
                },
            ],
        },
    ];

    // init google maps event listener
    function initGoogleMaps() {
        const buttonShowMaps = document.querySelector('#showGoogleMaps');
        // eslint-disable-next-line
        buttonShowMaps.addEventListener('click', function () {
            // add google maps script to DOM
            const gm = document.createElement('script');
            gm.type = 'text/javascript';
            gm.async = true;
            gm.src = this.dataset.gm;
            const s = document.getElementsByTagName('script')[0];
            s.parentNode.insertBefore(gm, s);

            // remove modal button
            const modalButton = document.querySelector('#showGoogleMapsModalBtn');
            modalButton.remove();
        });
    }

    // google maps callback function. this is a mandatory function for google maps api calls
    // eslint-disable-next-line
    window.showGoogleMaps = function() {
        const map = new google.maps.Map(document.getElementById('googleMap'), options);
        const styledMap = new google.maps.StyledMapType(stylers, { name: 'Intersnack Map' });
        // const styledMap = new google.maps.StyledMapType(styledMapCode, { name: 'Intersnack Map' });

        /**
         *  Setting style map as default view
         */
        map.mapTypes.set('styled_map', styledMap);
        map.setMapTypeId('styled_map');

        /**
         *  Set map center
         */
        // eslint-disable-next-line prefer-destructuring
        const $mapcenter = document.querySelector('#isnack-locations-mapcenter');

        let centerLat = 0;
        let centerLong = 0;

        if ($mapcenter) {
            const mapcenterStr = $mapcenter.dataset.mapcenter;
            if (mapcenterStr) {
                const mapcenter = JSON.parse(mapcenterStr);
                let center = {};
                mapcenter.forEach((valuecenter) => {
                    center = {
                        lat: parseFloat(valuecenter.latitude),
                        lng: parseFloat(valuecenter.longitude),
                    };
                    centerLat = parseFloat(valuecenter.latitude);
                    centerLong = parseFloat(valuecenter.longitude);
                });
                if (center) {
                    map.setCenter(center);
                    map.setZoom(6);
                }
            }
        }

        /**
         * Iteration through marker Object
         */
        // eslint-disable-next-line prefer-destructuring
        const pointsStr = $map.dataset.points;
        const points = JSON.parse(pointsStr);
        const icon = {
            url: '/typo3conf/ext/udg_package/Resources/Public/Images/SVG/Maps/Pin.svg',
            scaledSize: new google.maps.Size(35, 35),
        };
        let currenticon = 0;

        points.forEach((value, i) => {
            if (parseFloat(value.latitude) === centerLat && parseFloat(value.longitude) === centerLong) {
                currenticon = {
                    url: '/typo3conf/ext/udg_package/Resources/Public/Images/SVG/Maps/Pin.svg',
                    scaledSize: new google.maps.Size(50, 50),
                };
            } else {
                currenticon = icon;
            }
            const marker = new google.maps.Marker({
                position: {
                    lat: parseFloat(value.latitude),
                    lng: parseFloat(value.longitude),
                },
                map,
                animation: google.maps.Animation.DROP,
                icon: currenticon,
            });

            // eslint-disable-next-line
            google.maps.event.addListener(marker, 'click', (function () {
                // eslint-disable-next-line
                return function () {
                    const topScrollSpacer = 70;
                    const locationId = `ce__isnack-locations-item-location-${value.uid}`;
                    const scrollTarget = document.getElementById(locationId).offsetTop;
                    window.scrollTo({
                        top: scrollTarget - topScrollSpacer,
                        behavior: 'smooth',
                    });
                };
            })(marker, i));
        });
    };

    // run
    initGoogleMaps();
}
